<template>
  <div class="chat-messages">
    <div v-for="(message, index) in messages" :key="index" :class="['message-item', message.type]">
      <div v-if="message.type === messageType.sent && message.imageUrl" class="my-1 max-h-40 max-w-80 overflow-hidden">
        <img :src="message.imageUrl" />
      </div>
      <div v-if="message.text" class="chat-message-text">
        <span v-if="message.type === messageType.sent">{{ message.text }}</span>
        <MarkdownRender v-else :content="message.text" />
      </div>
    </div>
    <div v-if="isTyping" class="typing-indicator">
      <em>{{ $t('ChatBot.Typing') }}</em>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { messageType } from '@/common/constants'

export default defineComponent({
  props: {
    messages: {
      type: Array,
      default: undefined,
    },
    isTyping: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      messageType: messageType,
    }
  },
})
</script>

<style lang="scss" scoped>
.chat-messages {
  @apply w-full h-full overflow-y-auto flex flex-col p-3;
}

.message-item {
  @apply flex flex-col max-w-[75%];

  & img {
    @apply h-auto w-auto max-h-40 max-w-full border rounded-md;
  }
}

.chat-message-text {
  @apply p-2 my-1 rounded-md;
}

.sent {
  @apply text-white self-end items-end;

  & .chat-message-text {
    @apply bg-[#1f1584];
  }
}

.received {
  @apply self-start;

  & .chat-message-text {
    @apply bg-gray-300;
  }
}

.typing-indicator {
  @apply text-gray-500 italic mt-2 self-start animate-pulse;
}
</style>
